import styled from 'styled-components';
import H5 from 'UIComponents/elements/headings/H5';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import TicketToolbar from './TicketToolbar';
import ThreadToolbar from './ThreadToolbar';
import { getUserPermissions } from '../../tickets/operators/ticketGetters';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHeader = styled.div.withConfig({
  displayName: "ToolbarContainer__StyledHeader",
  componentId: "sc-1j577rh-0"
})(["border-bottom:1px solid ", ";background:", ";"], GREAT_WHITE, OLAF);
const ToolbarContainer = ({
  ticket,
  inboxId,
  threadId
}) => {
  const currentUserCanView = ticket ? getUserPermissions(ticket).currentUserCanView : false;
  const hasAssociatedTickets = !!ticket;
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  const shouldRenderThreadToolbar = !hasAssociatedTickets || !currentUserCanView;
  return /*#__PURE__*/_jsx(StyledHeader, {
    className: "p-x-4 p-y-2",
    children: /*#__PURE__*/_jsx(H5, {
      className: "m-bottom-0",
      "data-test-id": "sticky-subject-header",
      style: {
        lineHeight: 1
      },
      children: shouldRenderThreadToolbar || shouldLimitTicketFunctionality ? /*#__PURE__*/_jsx(ThreadToolbar, {
        threadId: threadId,
        inboxId: inboxId
      }) : /*#__PURE__*/_jsx(TicketToolbar, {
        ticket: ticket,
        threadId: threadId,
        inboxId: inboxId
      })
    })
  });
};
ToolbarContainer.displayName = 'TicketHeaderToolbar';
export default ToolbarContainer;